<template>
  <v-card :height="(large) ? 300 : 250" :width="(large) ? 400 : 300" elevation="4">
    <div style="padding: 2px 5px">
      {{ vehicle.numericPlate }}

      <span style="float: right">
                    <v-tooltip bottom open-delay="500">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          x-small
                          icon
                          v-bind="attrs"
                          v-on="on"
                          :disabled="vehicle.location === null"
                          @click.stop="onActionVisibility(vehicle)"
                        >
                          <v-icon v-if="$store.getters['online/isVisible'](vehicle)">mdi-eye</v-icon>
                          <v-icon v-else>mdi-eye-off</v-icon>
                        </v-btn>
                      </template>
                      <span>{{ $t("map.panel.online.tooltip.show_hide") }}</span>
                    </v-tooltip>

                    <v-tooltip bottom open-delay="500">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          x-small
                          icon
                          class="ml-1"
                          v-bind="attrs"
                          v-on="on"
                          :disabled="vehicle.location === null"
                          @click.stop="onActionVehicle(vehicle)"
                        >
                          <v-icon>mdi-crosshairs-gps</v-icon>
                        </v-btn>
                      </template>
                      <span>{{ $t("map.panel.online.tooltip.vehicle") }}</span>
                    </v-tooltip>

                    <v-tooltip bottom open-delay="500">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          x-small
                          icon
                          class="ml-1"
                          v-bind="attrs"
                          v-on="on"
                          :disabled="vehicle.location === null"
                          @click.stop="onActionHistory(vehicle)"
                        >
                          <v-icon>mdi-history</v-icon>
                        </v-btn>
                      </template>
                      <span>{{ $t("map.panel.online.tooltip.history") }}</span>
                    </v-tooltip>

                    <v-tooltip bottom open-delay="500">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          x-small
                          icon
                          class="ml-1"
                          v-bind="attrs"
                          v-on="on"
                          :disabled="vehicle.location === null"
                          @click.stop="onActionLogbook(vehicle)"
                        >
                          <v-icon>mdi-text-box-outline</v-icon>
                        </v-btn>
                      </template>
                      <span>{{ $t("map.panel.online.tooltip.logbook") }}</span>
                    </v-tooltip>

                  </span>
    </div>
    <l-map
      :center="center"
      :zoom="zoom"
      class="map-preview"
      ref="map"
      :style="{'z-index': 0, height: ((large) ? 200 : 150) + 'px'}"
      v-on:mouseover="mapsControlsVisible = true"
      v-on:mouseout="mapsControlsVisible = false"
      @ready="mapReady()"
      :options="mapOptions">
      <l-tile-layer
        :url="mapLayer.url"
        :attribution="mapLayer.attribution"
      />
      <GoogleLayer v-if="mapLayer.google"
                   :type="mapLayer.type"
                   :layer="mapLayer.layer"
      />
      <l-control position="topleft" v-if="mapsControlsVisible">
        <v-item-group class="v-btn-group-vertical">
          <v-tooltip style="z-index: 4000" bottom open-delay="500">
            <template v-slot:activator="{ on }">
              <v-btn
                elevation="2"
                color="white"
                x-small
                width="26px"
                height="30px"
                class="map-button"
                v-on:click="zoomIn()"
                v-on="on"
              >
                <v-icon>mdi-plus</v-icon>
              </v-btn>
            </template>
            <span>{{ $t("map.tooltip.zoom_in") }}</span>
          </v-tooltip>

          <v-tooltip style="z-index: 9999" bottom open-delay="500">
            <template v-slot:activator="{ on }">
              <v-btn
                elevation="2"
                color="white"
                x-small
                width="26px"
                height="30px"
                class="map-button"
                v-on:click="zoomOut()"
                v-on="on"
              >
                <v-icon>mdi-minus</v-icon>
              </v-btn>
            </template>
            <span>{{ $t("map.tooltip.zoom_out") }}</span>
          </v-tooltip>
        </v-item-group>
      </l-control>

    </l-map>
    <div style="padding: 2px 5px 1px 5px; font-size: 90%;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;">
      <template
        v-if="vehicle.ride !== null && (vehicle.ride.driver !== null || (vehicle.ride.driverIdentification !== null && vehicle.ride.driverCode !== null))">
        {{ getDriver(vehicle) }}
        <template v-if="vehicle.ride.driver !== null && vehicle.ride.driver.tachograph !== null">
          <span class="grey--text">&nbsp;•&nbsp;</span>
          <v-tooltip bottom open-delay="500">
            <template v-slot:activator="{ on, attrs }">
              <v-progress-linear
                :value="calcProgressValue(vehicle.ride.driver.tachograph.dayDriveAccumulation, vehicle.ride.driver.tachograph.dayDriveLimit)"
                height="14"
                rounded
                v-bind="attrs"
                v-on="on"
                color="orange"
                style="width: 110px; display: inline-block">
          <span style="font-size: 90%;">{{ formatTachographDuration(vehicle.ride.driver.tachograph.dayDriveLimit
            - vehicle.ride.driver.tachograph.dayDriveAccumulation) }}</span>
              </v-progress-linear>
            </template>
            <TachographTooltip :vehicle="vehicle" />
          </v-tooltip>

          <template v-if="large">
            &nbsp;
            <v-tooltip bottom open-delay="500">
              <template v-slot:activator="{ on, attrs }">
                <v-progress-linear
                  :value="calcProgressValue(vehicle.ride.driver.tachograph.weekDriveAccumulation, vehicle.ride.driver.tachograph.weekDriveLimit)"
                  height="14"
                  rounded
                  v-bind="attrs"
                  v-on="on"
                  color="blue"
                  style="width: 110px; display: inline-block">
          <span style="font-size: 90%;">{{ formatTachographDuration(vehicle.ride.driver.tachograph.weekDriveLimit
            - vehicle.ride.driver.tachograph.weekDriveAccumulation) }}</span>
                </v-progress-linear>
              </template>
              <TachographTooltip :vehicle="vehicle" />
            </v-tooltip>
          </template>
        </template>
      </template>
      <template v-else>
        <span class="font-italic grey--text">Nezmámý řidič</span>
      </template>
    </div>
    <div style="padding: 1px 5px 2px 5px; font-size: 90%;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;">
      <template v-if="vehicle.ride != null">
        {{ $t("enum.ride_type." + vehicle.ride.rideType) }}
        <span class="grey--text">&nbsp;•&nbsp;</span>
        {{ formatDuration(vehicle) }}
        <template v-if="vehicle.ride.driverQuality !== null">
          <span class="grey--text">&nbsp;•&nbsp;</span>
          <v-icon small>workspace_premium</v-icon>
          <span :class="[classQuality(vehicle.ride.driverQuality), 'font-weight-bold']"
                style="padding-left: 4px">{{ formatQuality(vehicle.ride.driverQuality) }}</span>
        </template>
      </template>
      <template v-if="large && vehicle.location != null && vehicle.location.speed > 0">
        <span class="grey--text">&nbsp;•&nbsp;</span>
        {{ formatSpeed(vehicle.location) }}
      </template>
    </div>
    <div style="padding: 1px 5px 2px 5px; font-size: 90%;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;">
      <country-flag class="small-flag-move" v-if="getLocationPlaceFlag(vehicle)"
                    :country="getLocationPlaceFlag(vehicle)" size="small" />
      {{ getLocationPlace(vehicle) }}
    </div>
  </v-card>
</template>

<script>
import GoogleLayer from "@/components/map/GoogleLayer.vue";
import maputils from "@/maputils";
import L from "leaflet";
import utils from "@/utils";
import TachographTooltip from "@/components/tooltip/TachographTooltip.vue";
import { DateTime } from "luxon";

export default {
  name: "VehiclePreview",

  components: { TachographTooltip, GoogleLayer },

  props: {
    vehicle: {
      type: Object,
      mandatory: true
    },
    large: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      center: [49.0414010, 13.0698517],
      zoom: 14,
      rotation: 0,
      map: null,
      mapOptions: {
        zoomControl: false,
        attributionControl: false,
        scrollWheelZoom: false,
        doubleClickZoom: false,
        dragging: true
      },
      mapsControlsVisible: false,
      vehicleLayer: null,
      vehicleSymbol: null,
      maps: maputils.MAP_LAYRES.filter(x => x.enabled),
      mapLayer: maputils.MAP_LAYRES[0]
    };
  },

  methods: {
    mapReady() {
      this.map = this.$refs.map.mapObject;

      this.vehicleLayer = new L.LayerGroup();
      this.vehicleLayer.addTo(this.map);

      this.refreshVehicle();
    },

    refreshVehicle() {
      if (this.vehicleSymbol !== null)
        this.vehicleSymbol.removeFrom(this.vehicleLayer);

      if (this.vehicle.location !== null && this.vehicle.location !== undefined) {
        this.map.setView([this.vehicle.location.latitude, this.vehicle.location.longitude], this.zoom);

        var options = maputils.trackSymbolVehicleOptions(this.vehicle);

        this.vehicleSymbol = maputils.trackSymbol(
          [this.vehicle.location.latitude, this.vehicle.location.longitude],
          options);

        this.vehicleSymbol.addTo(this.vehicleLayer);
      }
    },

    zoomIn() {
      this.map.zoomIn();
      this.zoom = this.map.zoom;
    },

    zoomOut() {
      this.map.zoomOut();
      this.zoom = this.map.zoom;
    },

    onActionVehicle(vehicle) {
      this.$router.push({
        name: "map/vehicle",
        params: { ccode: this.$store.state.auth.company.code, id: vehicle.vehicleId }
      });
    },

    onActionHistory(vehicle) {
      this.$router.push({
        name: "map/history",
        params: { ccode: this.$store.state.auth.company.code, id: vehicle.vehicleId }
      });
    },

    onActionLogbook(vehicle) {
      this.$router.push({
        name: "map/logbook",
        params: { ccode: this.$store.state.auth.company.code, id: vehicle.vehicleId }
      });
    },

    onActionVisibility(vehicle) {
      this.$store.dispatch("online/toggleVehicle", vehicle);
    },

    getLocationPlace(vehicle) {
      if (vehicle.location !== null && vehicle.location !== undefined && vehicle.location.place !== null)
        return utils.formatLocation(vehicle.location.place);
      else
        return "-";
    },

    getLocationPlaceFlag(vehicle) {
      if (vehicle.location !== null && vehicle.location !== undefined)
        return vehicle.location.countryCode;
      else
        return "";
    },

    formatDuration(vehicle) {
      if (vehicle.ride !== null) {
        if (vehicle.ride.rideState === "unfinished")
          return DateTime.fromISO(vehicle.ride.toTimestamp).toRelative(vehicle.ride.fromTimestamp);
        else if (vehicle.ride.rideState === "finished")
          return DateTime.fromISO(vehicle.ride.toTimestamp).toRelative();
      }
    },

    formatTime(location) {
      if (location !== null)
        return DateTime.fromISO(location.timestamp).toLocaleString(DateTime.DATETIME_SHORT);
      else
        return null;
    },

    formatSpeed(location) {
      if (location !== null && location.speed > 0)
        return location.speed + " km/h";
      else
        return null;
    },

    getDriver(vehicle) {
      if (vehicle.ride !== null && (vehicle.ride.driver !== null || (vehicle.ride.driverIdentification !== null && vehicle.ride.driverCode !== null))) {
        if (vehicle.ride.driver !== null)
          return vehicle.ride.driver.firstName + " " + vehicle.ride.driver.lastName;
        else if (vehicle.ride.driverCode !== null)
          return vehicle.ride.driverCode;
      }

      return "-";
    },

    formatQuality(value) {
      return utils.numberToString(value, 1, true);
    },

    classQuality(value) {
      return utils.colorClassQuality(value);
    },

    calcProgressValue(value, maxValue) {
      return value / (maxValue / 100);
    },

    formatTachographDuration(value) {
      if (value >= 0)
        return utils.formatHours(value);
      else
        return utils.formatHours(0);
    },

    formatUtcTimeDuration(time, duration, from = true) {
      if (time !== null) {
        if (from) {
          return DateTime.fromISO(time).minus({ minutes: duration }).toLocaleString(DateTime.DATETIME_SHORT);
        } else {
          return DateTime.fromISO(time).toLocaleString(DateTime.DATETIME_SHORT);
        }
      } else
        return null;
    }
  },

  watch: {
    vehicle: function() {
      this.refreshVehicle();
    },

    large: function() {
      this.$nextTick().then(() => {
        this.map.invalidateSize();
      });
    }
  }
};

</script>

<style scoped lang="sass">
.map-preview
  height: 100%
  width: 100%
</style>